export default __webpack_public_path__ + "static/media/GR00024_1-cup_mentor.c5269dd5.svg";